/**
 * Created by Administrador on 20/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('urgentService', urgentService)

    urgentService.$inject = ['$http', 'CONFIG', 'messageService'];

    function urgentService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CARGO_CONTROL + '/' + CONFIG.API + '/urgents';
        var service = {
            getUrgents: getUrgents,
            getUrgentList: getUrgentList,
            getUrgent: getUrgent,
            saveUrgent: saveUrgent,
            updateUrgent: updateUrgent,
            deleteUrgent: deleteUrgent
        }

        return service;

        function getUrgents(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getUrgentList(){
            return $http.get(urlBase + '/list')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getUrgent(id){
            return $http.get(urlBase + "/" + id )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('urgents')
                });
        }

        function saveUrgent(urgent){
            return $http.post(urlBase, urgent)
                .then(function(response){
                    messageService.register('urgents');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('urgents')
                });
        }

        function updateUrgent(urgentId, urgent){
            return $http.put(urlBase + "/" + urgentId, urgent)
                .then(function(response){
                    messageService.registerUpdate('urgents')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('urgents')
                });
        }

        function deleteUrgent(urgentId){
            return $http.delete(urlBase + "/" + urgentId)
                .then(function(response){
                    messageService.registerDelete('urgents');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('urgents');
                });
        }
    }
})();
